"use client";

import dynamic from "next/dynamic";
import { memo, type ComponentProps } from "react";
import cn from "clsx";
import styles from "./FaqSectionCityListing.module.scss"
import CityListingBannerForm from "@/components/pages/CityListingPage/CityBannerForm";
import FaqUIWithoutCategory, { type StrapiFaqItem } from "./FaqUIWithoutCategory/Faqs";


interface FaqWithFormProps {
  Faqs?: StrapiFaqItem[] | null;
  showTypes?: boolean;
  associatedPrograms: ComponentProps<typeof CityListingBannerForm>["associatedPrograms"];
  isLambdaAPI?: boolean;
  testimonials?: unknown;
  isSpecificPage?: boolean;
  seatsFilledUI?: number;
  isProgramListPage?: boolean;
  isMobile?: boolean;
  landingPageValue?: string;
  Heading?:string
  isCityPage?:boolean
  RFIHeading?:string
}

const FaqWithForm: React.FC<FaqWithFormProps> = ({
  Faqs,
  associatedPrograms,
  isLambdaAPI,
  isSpecificPage = false,
  isCityPage=false,
  RFIHeading="",
  showTypes=false
}) => {
  return (
    <>
      <section className={cn(styles.container, "lining-nums" ,isCityPage && styles.cityPage)}>
        <div
          className={`${isSpecificPage ? styles.layoutSpecific : styles.layout} ,${isLambdaAPI ? styles.lpLayout : styles.layout}`}
        >
          <div className={styles["faq-section"]}>
          <FaqUIWithoutCategory isHome={true} faqs={Faqs} showTypes={showTypes} />
          </div>
          <div className={styles["lead-form-section"]}>
            <div className={cn("form-wrapper", styles.formSection)}>
             <CityListingBannerForm  RFIHeading={RFIHeading}  associatedPrograms={associatedPrograms}  isSeatsFilledUI={false} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

 export default memo(FaqWithForm);
